import { render, staticRenderFns } from "./ReportCenterPublic.vue?vue&type=template&id=23533b58&scoped=true"
import script from "./ReportCenterPublic.vue?vue&type=script&lang=js"
export * from "./ReportCenterPublic.vue?vue&type=script&lang=js"
import style0 from "./ReportCenterPublic.vue?vue&type=style&index=0&id=23533b58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23533b58",
  null
  
)

export default component.exports